import React from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import image1 from "../images/1.PNG"; // top hero image
import ServiceDetail1 from "../components/ServiceDetail1";
import ServiceDetail2 from "../components/ServiceDetail2";
import heroVideo from "../videos/hero_video.mp4";
import Footer from "./Footer";
const ServiceDetails = () => {
  return (
    
    <div>
          {/* Header Section */}
          
          <section
      id="header"
      className="jumbotron text-center text-white d-flex flex-column justify-content-center align-items-center"
      style={{
        height: "70vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Video Background */}
      <video
        src={heroVideo}
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      />
    
      {/* Header Content */}
      <h1 className="display-3 fw-bold">Services Details</h1>
      <p className="lead">
        Skilled professionals ready to handle your home and office needs.
      </p>
      <div>
        <a href="/Booking" className="btn btn-primary me-2">
          Get Started
        </a>
        <a href="/Learn" className="btn btn-secondary">
          Learn More
        </a>
      </div>
    </section>
    

      {/* 🧰 Service Detail Section */}
      <ServiceDetail1 />
      <ServiceDetail2 />

      {/* 📩 Footer */}
    {/* 📱 Service 6 - Footer with WhatsApp */}
<div className="whatsapp-wrapper d-flex justify-content-center">
  <div className="whatsapp-section text-center py-5 px-4">
    <h3 className="fw-bold mb-3 text-white">
      Chat with Us on WhatsApp <br /> Get Instant Support
    </h3>
    <div className="d-flex justify-content-center">
      <a
        href="https://wa.me/94771234567" // replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        className="btn whatsapp-btn fw-bold px-4 py-2 d-flex align-items-center gap-2"
      >
        <i className="fa-brands fa-whatsapp"></i>
        Chat Now
      </a>
    </div>
  </div>
</div>


{/* Footer */}
<Footer />

    </div>
  );
};

export default ServiceDetails;
